import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { STICKY_SIDE_PANEL_CLASS } from '@/styles/stickySidePanel';

const SUMMARY_PANEL_STICKY_CLASS = cn(STICKY_SIDE_PANEL_CLASS, 'lg:col-start-2 lg:row-start-1');

interface SummarySideLayoutProps {
  summary: ReactNode;
  children: ReactNode;
}

export function SummarySideLayout({ summary, children }: SummarySideLayoutProps) {
  return (
    <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_20rem] lg:items-start">
      <div className={SUMMARY_PANEL_STICKY_CLASS}>{summary}</div>
      <div className="flex min-w-0 flex-col gap-4 lg:col-start-1 lg:row-start-1">{children}</div>
    </div>
  );
}
